// Customizable Area Start
import React from "react";
import { Box, Typography } from "@material-ui/core";

// Placeholder. The ledger lives at GET/PUT
// bx_block_order_management/admin_driver_attendances — attendance across a date
// range, plus punch corrections. Today's shift for a single driver is already
// shown in the Driver Tracker detail dialog.
export default class DriverAttendance extends React.Component {
  render() {
    return (
      <Box style={webStyle.wrapper} data-test-id="driverAttendancePage">
        <Typography style={webStyle.title}>Driver Attendance</Typography>
        <Typography style={webStyle.body}>
          Not built yet. Attendance for the last 14 days is available per driver
          from the Driver Tracker board.
        </Typography>
      </Box>
    );
  }
}

const webStyle: { [key: string]: React.CSSProperties } = {
  wrapper: {
    fontFamily: "Montserrat",
    padding: "24px 48px",
    background: "#FFFFFF",
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: 24,
    fontWeight: 600,
    color: "#1A1A1A",
    marginBottom: 12,
  },
  body: {
    fontFamily: "Montserrat",
    fontSize: 15,
    color: "#64748B",
  },
};
// Customizable Area End
